export const setLocalStorageItem = (name, value) => {
	localStorage.setItem(name, JSON.stringify(value));
};

export const getLocalStorageItem = name => {
	const textValue = localStorage.getItem(name);

	try {
		return JSON.parse(textValue);
	} catch (_e) {
		return null;
	}
};
